<template>
  <footer :class="$style.footer">
    <ParagraphBody>
      We encourage you to experiment with features outside of your
      subscription so you can determine whether they'll work for you. We'll
      follow up with you periodically to discuss the addition of new features
      you're using to the subscription. Check out our
      <ExternalLink
        :href="externalLinkHref"
        :text="externalLinkText"
        @click="handleFairUsePolicyClicked"
      />.
    </ParagraphBody>
  </footer>
</template>

<script>
import { ParagraphBody } from '@jumpcloud/ui-components';
import { eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import ExternalLink from 'components/ExternalLink.vue';

const {
  description,
  text,
  toUrl,
} = eventProperties;

export default {
  name: 'PricingFooter',

  components: {
    ExternalLink,
    ParagraphBody,
  },

  data() {
    return {
      externalLinkHref: 'https://jumpcloud.com/fair-use-policy',
      externalLinkText: 'fair use policy',
    };
  },

  methods: {
    handleFairUsePolicyClicked() {
      this.$emit('fairUsePolicyClicked', {
        [description]: 'opens fair use policy in a new tab',
        [text]: this.externalLinkText,
        [toUrl]: this.externalLinkHref,
      });
    },
  },
};
</script>

<style module>
.footer {
  background-color: var(--jcGrey100);
  padding: 30px;
}
</style>
